// extracted by mini-css-extract-plugin
export default {"buyNowButton":"F_M_Cv"};